export const fontsList = [
  'ABeeZee',
  'Abel',
  'Abhaya Libre',
  'Abril Fatface',
  'Aclonica',
  'Acme',
  'Actor',
  'Adamina',
  'Advent Pro',
  'Aguafina Script',
  'Akronim',
  'Aladin',
  'Alata',
  'Alatsi',
  'Aldrich',
  'Alef',
  'Alegreya',
  'Alegreya SC',
  'Alegreya Sans',
  'Alegreya Sans SC',
  'Aleo',
  'Alex Brush',
  'Alfa Slab One',
  'Alice',
  'Alike',
  'Alike Angular',
  'Allan',
  'Allerta',
  'Allerta Stencil',
  'Allura',
  'Almendra',
  'Almendra Display',
  'Almendra SC',
  'Amarante',
  'Amaranth',
  'Amatic SC',
  'Amatica SC',
  'Amethysta',
  'Amiko',
  'Amiri',
  'Amita',
  'Anaheim',
  'Andada',
  'Andika',
  'Angkor',
  'Annie Use Your Telescope',
  'Anonymous Pro',
  'Antic',
  'Antic Didone',
  'Antic Slab',
  'Anton',
  'Arapey',
  'Arbutus',
  'Arbutus Slab',
  'Architects Daughter',
  'Archivo',
  'Archivo Black',
  'Archivo Narrow',
  'Aref Ruqaa',
  'Arima Madurai',
  'Arimo',
  'Arizonia',
  'Armata',
  'Arsenal',
  'Artifika',
  'Arvo',
  'Arya',
  'Asap',
  'Asap Condensed',
  'Asar',
  'Asset',
  'Assistant',
  'Astloch',
  'Asul',
  'Athiti',
  'Atma',
  'Atomic Age',
  'Aubrey',
  'Audiowide',
  'Autour One',
  'Average',
  'Average Sans',
  'Averia Gruesa Libre',
  'Averia Libre',
  'Averia Sans Libre',
  'Averia Serif Libre',
  'Bad Script',
  'Bahiana',
  'Bai Jamjuree',
  'Baloo',
  'Baloo 2',
  'Baloo Bhai',
  'Baloo Bhaina',
  'Baloo Chettan',
  'Baloo Da',
  'Baloo Paaji',
  'Baloo Tamma',
  'Baloo Tamma 2',
  'Baloo Thambi',
  'Balsamiq Sans',
  'Balthazar',
  'Bangers',
  'Barlow',
  'Barlow Condensed',
  'Barlow Semi Condensed',
  'Barrio',
  'Basic',
  'Baskervville',
  'Battambang',
  'Baumans',
  'Bayon',
  'Be Vietnam',
  'Bebas Neue',
  'Belgrano',
  'Bellefair',
  'Belleza',
  'BenchNine',
  'Bentham',
  'Berkshire Swash',
  'Bevan',
  'Big Shoulders Display',
  'Bigelow Rules',
  'Bigshot One',
  'Bilbo',
  'Bilbo Swash Caps',
  'BioRhyme',
  'BioRhyme Expanded',
  'Biryani',
  'Bitter',
  'Black Han Sans',
  'Black Ops One',
  'Blinker',
  'Bokor',
  'Bonbon',
  'Boogaloo',
  'Bowlby One',
  'Bowlby One SC',
  'Brawler',
  'Bree Serif',
  'Bubblegum Sans',
  'Bubbler One',
  'Buda',
  'Buenard',
  'Bungee',
  'Bungee Hairline',
  'Bungee Inline',
  'Bungee Outline',
  'Bungee Shade',
  'Butcherman',
  'Butterfly Kids',
  'Cabin',
  'Cabin Condensed',
  'Cabin Sketch',
  'Caesar Dressing',
  'Cagliostro',
  'Cairo',
  'Calligraffitti',
  'Cambay',
  'Cambo',
  'Candal',
  'Cantarell',
  'Cantata One',
  'Cantora One',
  'Capriola',
  'Cardo',
  'Carme',
  'Carrois Gothic',
  'Carrois Gothic SC',
  'Carter One',
  'Castoro',
  'Catamaran',
  'Caudex',
  'Caveat',
  'Caveat Brush',
  'Cedarville Cursive',
  'Ceviche One',
  'Chakra Petch',
  'Changa',
  'Changa One',
  'Chango',
  'Charm',
  'Chathura',
  'Chau Philomene One',
  'Chela One',
  'Chelsea Market',
  'Chenla',
  'Cherry Cream Soda',
  'Cherry Swash',
  'Chewy',
  'Chicle',
  'Chivo',
  'Chonburi',
  'Cinzel',
  'Cinzel Decorative',
  'Clicker Script',
  'Coda',
  'Coda Caption',
  'Codystar',
  'Coiny',
  'Combo',
  'Comfortaa',
  'Comic Neue',
  'Coming Soon',
  'Commissioner',
  'Concert One',
  'Condiment',
  'Content',
  'Contrail One',
  'Convergence',
  'Cookie',
  'Copse',
  'Corben',
  'Cormorant',
  'Cormorant Garamond',
  'Cormorant Infant',
  'Cormorant SC',
  'Cormorant Unicase',
  'Cormorant Upright',
  'Courgette',
  'Courier Prime',
  'Cousine',
  'Coustard',
  'Covered By Your Grace',
  'Crafty Girls',
  'Creepster',
  'Crete Round',
  'Crimson Pro',
  'Crimson Text',
  'Croissant One',
  'Crushed',
  'Cuprum',
  'Cutive',
  'Cutive Mono',
  'DM Sans',
  'DM Serif Display',
  'DM Serif Text',
  'Damion',
  'Dancing Script',
  'Dangrek',
  'Darker Grotesque',
  'David Libre',
  'Dawning of a New Day',
  'Days One',
  'Dekko',
  'Delius',
  'Delius Swash Caps',
  'Delius Unicase',
  'Della Respira',
  'Denk One',
  'Devonshire',
  'Dhurjati',
  'Didact Gothic',
  'Diplomata',
  'Diplomata SC',
  'Do Hyeon',
  'Domine',
  'Donegal One',
  'Doppio One',
  'Dorsa',
  'Dosis',
  'Dr Sugiyama',
  'Droid Sans',
  'Droid Sans Mono',
  'Droid Serif',
  'Duru Sans',
  'Dynalight',
  'EB Garamond',
  'Eagle Lake',
  'Eater',
  'Economica',
  'Eczar',
  'Ek Mukta',
  'El Messiri',
  'Electrolize',
  'Elsie',
  'Elsie Swash Caps',
  'Emblema One',
  'Emilys Candy',
  'Encode Sans',
  'Encode Sans Condensed',
  'Engagement',
  'Englebert',
  'Enriqueta',
  'Epilogue',
  'Erica One',
  'Esteban',
  'Euphoria Script',
  'Ewert',
  'Exo',
  'Exo 2',
  'Expletus Sans',
  'Fanwood Text',
  'Farsan',
  'Fascinate',
  'Fascinate Inline',
  'Faster One',
  'Fasthand',
  'Fauna One',
  'Faustina',
  'Federant',
  'Federo',
  'Felipa',
  'Fenix',
  'Finger Paint',
  'Fira Mono',
  'Fira Sans',
  'Fira Sans Condensed',
  'Fira Sans Extra Condensed',
  'Fjalla One',
  'Fjord One',
  'Flamenco',
  'Flavors',
  'Fondamento',
  'Fontdiner Swanky',
  'Forum',
  'Francois One',
  'Frank Ruhl Libre',
  'Freckle Face',
  'Fredericka the Great',
  'Fredoka One',
  'Freehand',
  'Fresca',
  'Frijole',
  'Fruktur',
  'Fugaz One',
  'GFS Didot',
  'GFS Neohellenic',
  'Gabriela',
  'Gafata',
  'Galada',
  'Galdeano',
  'Galindo',
  'Gelasio',
  'Gentium Basic',
  'Gentium Book Basic',
  'Geo',
  'Geostar',
  'Geostar Fill',
  'Germania One',
  'Gidugu',
  'Gilda Display',
  'Give You Glory',
  'Glass Antiqua',
  'Glegoo',
  'Gloria Hallelujah',
  'Goblin One',
  'Gochi Hand',
  'Gorditas',
  'Gothic A1',
  'Goudy Bookletter 1911',
  'Graduate',
  'Grand Hotel',
  'Gravitas One',
  'Great Vibes',
  'Griffy',
  'Gruppo',
  'Gudea',
  'Gurajada',
  'Habibi',
  'Halant',
  'Hammersmith One',
  'Hanalei',
  'Hanalei Fill',
  'Handlee',
  'Hanuman',
  'Happy Monkey',
  'Harmattan',
  'Headland One',
  'Heebo',
  'Henny Penny',
  'Herr Von Muellerhoff',
  'Hind',
  'Hind Guntur',
  'Hind Madurai',
  'Hind Siliguri',
  'Hind Vadodara',
  'Holtwood One SC',
  'Homemade Apple',
  'Homenaje',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'IBM Plex Sans Condensed',
  'IBM Plex Serif',
  'IM Fell DW Pica',
  'IM Fell DW Pica SC',
  'IM Fell Double Pica',
  'IM Fell Double Pica SC',
  'IM Fell English',
  'IM Fell English SC',
  'IM Fell French Canon',
  'IM Fell French Canon SC',
  'IM Fell Great Primer',
  'IM Fell Great Primer SC',
  'Iceberg',
  'Iceland',
  'Imprima',
  'Inconsolata',
  'Inder',
  'Indie Flower',
  'Inika',
  'Inknut Antiqua',
  'Inter',
  'Irish Grover',
  'Istok Web',
  'Italiana',
  'Italianno',
  'Itim',
  'Jacques Francois',
  'Jacques Francois Shadow',
  'Jaldi',
  'Jim Nightshade',
  'Jockey One',
  'Jolly Lodger',
  'Jomhuria',
  'Josefin Sans',
  'Josefin Slab',
  'Jost',
  'Joti One',
  'Jua',
  'Judson',
  'Julee',
  'Julius Sans One',
  'Junge',
  'Jura',
  'Just Another Hand',
  'Just Me Again Down Here',
  'K2D',
  'Kadwa',
  'Kalam',
  'Kameron',
  'Kanit',
  'Kantumruy',
  'Karla',
  'Karma',
  'Katibeh',
  'Kaushan Script',
  'Kavivanar',
  'Kavoon',
  'Kdam Thmor',
  'Keania One',
  'Kelly Slab',
  'Kenia',
  'Khand',
  'Khmer',
  'Khula',
  'Kite One',
  'Knewave',
  'KoHo',
  'Kosugi',
  'Kosugi Maru',
  'Kotta One',
  'Koulen',
  'Kranky',
  'Kreon',
  'Kristi',
  'Krona One',
  'Krub',
  'Kumar One',
  'Kumar One Outline',
  'Kumbh Sans',
  'Kurale',
  'La Belle Aurore',
  'Laila',
  'Lakki Reddy',
  'Lalezar',
  'Lancelot',
  'Lateef',
  'Lato',
  'League Script',
  'Leckerli One',
  'Ledger',
  'Lekton',
  'Lemon',
  'Lemonada',
  'Lexend',
  'Lexend Deca',
  'Libre Baskerville',
  'Libre Caslon Text',
  'Libre Franklin',
  'Life Savers',
  'Lilita One',
  'Lily Script One',
  'Limelight',
  'Linden Hill',
  'Literata',
  'Lobster',
  'Lobster Two',
  'Londrina Outline',
  'Londrina Shadow',
  'Londrina Sketch',
  'Londrina Solid',
  'Lora',
  'Love Ya Like A Sister',
  'Loved by the King',
  'Lovers Quarrel',
  'Luckiest Guy',
  'Lusitana',
  'Lustria',
  'M PLUS 1p',
  'M PLUS rounded-sm 1c',
  'Macondo',
  'Macondo Swash Caps',
  'Mada',
  'Magra',
  'Maiden Orange',
  'Maitree',
  'Mako',
  'Mali',
  'Mallanna',
  'Mandali',
  'Manjari',
  'Manrope',
  'Marcellus',
  'Marcellus SC',
  'Marck Script',
  'Margarine',
  'Markazi Text',
  'Marko One',
  'Marmelad',
  'Martel',
  'Martel Sans',
  'Marvel',
  'Mate',
  'Mate SC',
  'Maven Pro',
  'McLaren',
  'Meddon',
  'MedievalSharp',
  'Medula One',
  'Meera Inimai',
  'Megrim',
  'Meie Script',
  'Merienda',
  'Merienda One',
  'Merriweather',
  'Merriweather Sans',
  'Metal',
  'Metal Mania',
  'Metamorphous',
  'Metrophobic',
  'Michroma',
  'Milonga',
  'Miltonian',
  'Miltonian Tattoo',
  'Miniver',
  'Miriam Libre',
  'Mirza',
  'Miss Fajardose',
  'Mitr',
  'Modak',
  'Modern Antiqua',
  'Mogra',
  'Molengo',
  'Molle',
  'Monda',
  'Monofett',
  'Monoton',
  'Monsieur La Doulaise',
  'Montaga',
  'Montez',
  'Montserrat',
  'Montserrat Alternates',
  'Montserrat Subrayada',
  'Moul',
  'Moulpali',
  'Mountains of Christmas',
  'Mouse Memoirs',
  'Mr Bedfort',
  'Mr Dafoe',
  'Mr De Haviland',
  'Mrs Saint Delafield',
  'Mrs Sheppards',
  'Mukta',
  'Mukta Malar',
  'Mukta Vaani',
  'Muli',
  'Mulish',
  'Mystery Quest',
  'NTR',
  'Nanum Brush Script',
  'Nanum Gothic',
  'Nanum Gothic Coding',
  'Nanum Myeongjo',
  'Nanum Pen Script',
  'Neucha',
  'Neuton',
  'New Rocker',
  'News Cycle',
  'Niconne',
  'Niramit',
  'Nixie One',
  'Nobile',
  'Nokora',
  'Norican',
  'Nosifer',
  'Nothing You Could Do',
  'Noticia Text',
  'Noto Sans',
  'Noto Sans HK',
  'Noto Sans JP',
  'Noto Sans KR',
  'Noto Sans SC',
  'Noto Sans TC',
  'Noto Serif',
  'Noto Serif JP',
  'Noto Serif KR',
  'Noto Serif SC',
  'Noto Serif TC',
  'Nova Cut',
  'Nova Flat',
  'Nova Mono',
  'Nova Oval',
  'Nova Round',
  'Nova Script',
  'Nova Slim',
  'Nova Square',
  'Numans',
  'Nunito',
  'Nunito Sans',
  'Odor Mean Chey',
  'Offside',
  'Old Standard TT',
  'Oldenburg',
  'Oleo Script',
  'Oleo Script Swash Caps',
  'Open Sans',
  'Open Sans Condensed',
  'Oranienbaum',
  'Orbitron',
  'Oregano',
  'Orienta',
  'Original Surfer',
  'Oswald',
  'Over the Rainbow',
  'Overlock',
  'Overlock SC',
  'Overpass',
  'Overpass Mono',
  'Ovo',
  'Oxygen',
  'Oxygen Mono',
  'PT Mono',
  'PT Sans',
  'PT Sans Caption',
  'PT Sans Narrow',
  'PT Serif',
  'PT Serif Caption',
  'Pacifico',
  'Padauk',
  'Palanquin',
  'Palanquin Dark',
  'Pangolin',
  'Paprika',
  'Parisienne',
  'Passero One',
  'Passion One',
  'Pathway Gothic One',
  'Patrick Hand',
  'Patrick Hand SC',
  'Pattaya',
  'Patua One',
  'Pavanam',
  'Paytone One',
  'Peddana',
  'Peralta',
  'Permanent Marker',
  'Petit Formal Script',
  'Petrona',
  'Philosopher',
  'Piedra',
  'Pinyon Script',
  'Pirata One',
  'Plaster',
  'Play',
  'Playball',
  'Playfair Display',
  'Playfair Display SC',
  'Podkova',
  'Poiret One',
  'Poller One',
  'Poly',
  'Pompiere',
  'Pontano Sans',
  'Poppins',
  'Port Lligat Sans',
  'Port Lligat Slab',
  'Pragati Narrow',
  'Prata',
  'Preahvihear',
  'Press Start 2P',
  'Pridi',
  'Princess Sofia',
  'Prociono',
  'Prompt',
  'Prosto One',
  'Proza Libre',
  'Public Sans',
  'Puritan',
  'Purple Purse',
  'Quando',
  'Quantico',
  'Quattrocento',
  'Quattrocento Sans',
  'Questrial',
  'Quicksand',
  'Quintessential',
  'Qwigley',
  'Racing Sans One',
  'Radley',
  'Rajdhani',
  'Rakkas',
  'Raleway',
  'Raleway Dots',
  'Ramabhadra',
  'Ramaraja',
  'Rambla',
  'Rammetto One',
  'Ranchers',
  'Rancho',
  'Ranga',
  'Rasa',
  'Rationale',
  'Ravi Prakash',
  'Recursive',
  'Red Hat Display',
  'Red Hat Text',
  'Redressed',
  'Reem Kufi',
  'Reenie Beanie',
  'Revalia',
  'Rhodium Libre',
  'Ribeye',
  'Ribeye Marrow',
  'Righteous',
  'Risque',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Rochester',
  'Rock Salt',
  'Rokkitt',
  'Romanesco',
  'Ropa Sans',
  'Rosario',
  'Rosarivo',
  'Rouge Script',
  'Rozha One',
  'Rubik',
  'Rubik Mono One',
  'Ruda',
  'Rufina',
  'Ruge Boogie',
  'Ruluko',
  'Rum Raisin',
  'Ruslan Display',
  'Russo One',
  'Ruthie',
  'Rye',
  'Sacramento',
  'Sahitya',
  'Sail',
  'Saira',
  'Saira Condensed',
  'Saira Extra Condensed',
  'Saira Semi Condensed',
  'Salsa',
  'Sanchez',
  'Sancreek',
  'Sansita',
  'Sarabun',
  'Sarala',
  'Sarina',
  'Sarpanch',
  'Satisfy',
  'Sawarabi Gothic',
  'Sawarabi Mincho',
  'Scada',
  'Scheherazade',
  'Schoolbell',
  'Scope One',
  'Seaweed Script',
  'Secular One',
  'Sen',
  'Sevillana',
  'Seymour One',
  'Shadows Into Light',
  'Shadows Into Light Two',
  'Shanti',
  'Share',
  'Share Tech',
  'Share Tech Mono',
  'Shojumaru',
  'Short Stack',
  'Shrikhand',
  'Siemreap',
  'Sigmar One',
  'Signika',
  'Signika Negative',
  'Simonetta',
  'Sintony',
  'Sirin Stencil',
  'Six Caps',
  'Skranji',
  'Slabo 13px',
  'Slabo 27px',
  'Slackey',
  'Smokum',
  'Smythe',
  'Sniglet',
  'Snippet',
  'Snowburst One',
  'Sofadi One',
  'Sofia',
  'Sonsie One',
  'Sora',
  'Sorts Mill Goudy',
  'Source Code Pro',
  'Source Sans Pro',
  'Source Serif Pro',
  'Space Grotesk',
  'Space Mono',
  'Spartan',
  'Special Elite',
  'Spectral',
  'Spicy Rice',
  'Spinnaker',
  'Spirax',
  'Squada One',
  'Sree Krushnadevaraya',
  'Sriracha',
  'Staatliches',
  'Stalemate',
  'Stalinist One',
  'Stardos Stencil',
  'Stint Ultra Condensed',
  'Stint Ultra Expanded',
  'Stoke',
  'Strait',
  'Sue Ellen Francisco',
  'Suez One',
  'Sumana',
  'Sunshiney',
  'Supermercado One',
  'Sura',
  'Suranna',
  'Suravaram',
  'Suwannaphum',
  'Swanky and Moo Moo',
  'Syncopate',
  'Tajawal',
  'Tangerine',
  'Taprom',
  'Tauri',
  'Taviraj',
  'Teko',
  'Telex',
  'Tenali Ramakrishna',
  'Tenor Sans',
  'Text Me One',
  'Thasadith',
  'The Girl Next Door',
  'Tienne',
  'Tillana',
  'Timmana',
  'Tinos',
  'Titan One',
  'Titillium Web',
  'Trade Winds',
  'Trirong',
  'Trocchi',
  'Trochut',
  'Trykker',
  'Tulpen One',
  'Turret Road',
  'Ubuntu',
  'Ubuntu Condensed',
  'Ubuntu Mono',
  'Ultra',
  'Uncial Antiqua',
  'Underdog',
  'Unica One',
  'UnifrakturCook',
  'UnifrakturMaguntia',
  'Unkempt',
  'Unlock',
  'Unna',
  'VT323',
  'Vampiro One',
  'Varela',
  'Varela Round',
  'Vast Shadow',
  'Vesper Libre',
  'Vibur',
  'Vidaloka',
  'Viga',
  'Voces',
  'Volkhov',
  'Vollkorn',
  'Voltaire',
  'Waiting for the Sunrise',
  'Wallpoet',
  'Walter Turncoat',
  'Warnes',
  'Wellfleet',
  'Wendy One',
  'Wire One',
  'Work Sans',
  'Yanone Kaffeesatz',
  'Yantramanav',
  'Yatra One',
  'Yellowtail',
  'Yeseva One',
  'Yesteryear',
  'Yrsa',
  'Zeyada',
  'Zilla Slab',
]
